import Component from '../abstracts/Component';
import NotifyMeLogic from '../businessLogic/NotifyMeLogic';

export default class NotifyMeComponent extends Component {
    
    get SELECTORS() {
        return {
            main: '.c-sizes-row',
            toBagBtn: '.jsToBagBtn',
            notifyMeBtn : '.jsNotifyMeBtn',
            btnSize: '.c-s-r__size',
            sizesIntoSticky:'[data-into-sticky="true"]',
            unavailable: '[data-unavailable="true"]',
            blockNotifyMe: '.c-pdp-notifyme',
            selectedBtnSize : '.selected-size',
            sizeLabel: '.c-s-r__text__size-label',
            hiddenInput: '#jsSizeSelectedInput',
            fixedBar: '#jsFixedBar',
            closeNotify: '.jsCloseNotify'
        };
    }
    
    constructor() {
        super();
        this.selecetedSizeClass = 'selected-size';
        this.showFormClass = 'show-form';
        this.fixedBarNotifyClass = 'notify-bar-mode';
    }
    showForm(bool){
        let formBlock = document.querySelector(this.SELECTORS.blockNotifyMe);
        let showClass = this.showFormClass;
        if(!bool){
            formBlock.classList.remove(showClass);
        }else{
            formBlock.classList.add(showClass);
        }
    }
    selectAllSizes(label){
        let btnSizes = document.querySelectorAll(this.SELECTORS.btnSize);
        for( let btn of btnSizes){
            if(btn.dataset.size == label)
                btn.classList.add(this.selecetedSizeClass);
        }
    }
    unselectAllSizes(){
        let selectedBtns = document.querySelectorAll(this.SELECTORS.selectedBtnSize);
        for( let btn of selectedBtns){
            btn.classList.remove(this.selecetedSizeClass);
        }
    }
    changeSizeLabel(label){
        let sizeLabels= document.querySelectorAll(this.SELECTORS.sizeLabel);
        for(let dataLabel of sizeLabels) {         
          $(dataLabel).attr("data-size-selected",label); //non dataLabel.dataset.sizeSelected = label; per IE11
        }
    }
    fixedBarNotifyMe(bool){
        let fixedBar = document.querySelector(this.SELECTORS.fixedBar);
        
        if(fixedBar) {
          let notifyMeClass = this.fixedBarNotifyClass;
        
          if(bool === true){
            fixedBar.classList.add(notifyMeClass);
          }else{
            fixedBar.classList.remove(notifyMeClass)
          }
        }
    }
    sizeBarHandler(){
        let sizeBtns = document.querySelectorAll(this.SELECTORS.btnSize);
        let hiddenInput = document.querySelector(this.SELECTORS.hiddenInput);
        let selectedClass = this.selecetedSizeClass;
        for(let size of sizeBtns){
            let label = '--';
            size.addEventListener('click',()=>{
                label = size.dataset.size;
                this.unselectAllSizes();
                this.changeSizeLabel(label);
                this.selectAllSizes(label);
                hiddenInput.value= size.dataset.size;
                let unavailable = size.dataset.unavailable == 'true';
                this.fixedBarNotifyMe(unavailable);
                this.showForm(unavailable);
                size.classList.add(selectedClass);
                this.$emit(this.$customEvents.PRODUCT_EVENTS.sizechanged,  {button: size});
                this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, size)
            });
            if(size.dataset.uniqueSize == 'true') $(size).trigger('click');
        }
    }
    // unavailableHandler(){
    //     let unavailableBtns = document.querySelectorAll(this.SELECTORS.unavailable);
    //     let hiddenInput = document.querySelector(this.SELECTORS.hiddenInput);
        
    //     for(let unavailableBtn of unavailableBtns){
    //         unavailableBtn.addEventListener('click',()=>{
    //             hiddenInput.value= unavailableBtn.dataset.size;
    //             this.fixedBarNotifyMe(true);
    //             this.showForm(true);
    //         })
    //     }
    // }
    sizeNotSelected(){
        let sizes = document.querySelectorAll(this.SELECTORS.selectedBtnSize);
        if(sizes.length <= 0){
            return true;
        }else{
            return false;
        }
    }
    validateInputHidden(){
        let hiddenInput = document.querySelector(this.SELECTORS.hiddenInput);
        if(hiddenInput.value !==""){
            return true;
        }
    }
    ctaNotifyMeHandler(){
        let ctaNotifyMe = document.querySelector(this.SELECTORS.notifyMeBtn);
        
        if(ctaNotifyMe) {
          let errMess = ctaNotifyMe.dataset.errorMessage;
        
          let handlerDesk = ()=>{
            if(this.sizeNotSelected()){
              console.log('no size selected');
              this.setSizeErrorMessage(errMess);
            }else{
              this.setSizeErrorMessage('');
            }
          }
          let handlerMobile = ()=>{
            this.showForm(true);
          }
          if(this.isMobile()){
            ctaNotifyMe.addEventListener('click',handlerMobile);
          }else{
            ctaNotifyMe.addEventListener('click',handlerDesk);
          }
        }
    }
    ctaToBagHandler(){
        let btns = document.querySelectorAll(this.SELECTORS.toBagBtn);
        for(let ctaToBag of btns){
          let errMess = ctaToBag.dataset.errorMessage;
          ctaToBag.addEventListener('click',()=>{
            if(this.sizeNotSelected()){
                console.log('no size selected');
                this.setSizeErrorMessage(errMess);
            }else{
                this.setSizeErrorMessage('');
            }
          });
        }
    }
    setSizeErrorMessage(message){
        let mainSizeRow = document.querySelector(this.SELECTORS.main);
        mainSizeRow.setAttribute('data-error-message',message);
    }
    isMobile(){
        let mq = window.matchMedia('(max-width:767px)');
        let isMobile = mq.matches;
        return isMobile;
    }
    mobileLayerHandler(){
        const closeBtn = document.querySelector(this.SELECTORS.closeNotify);
        
        if(this.isMobile()){
            closeBtn.addEventListener('click',()=>{
                this.showForm(false);
            })
        }
    }
    render() {
        this.log("Rendering...");
        this.NotifyMeLogic = new NotifyMeLogic(this);
        this.NotifyMeLogic.render();
        if (document.querySelector(this.SELECTORS.main)) {

            this.ctaToBagHandler();
            this.mobileLayerHandler();
            //this.unavailableHandler();
            this.sizeBarHandler();
            this.ctaNotifyMeHandler();
        }
    }
}
